<template>
  <section>
    <section class="stock-index">
      <p class="title">指数行情</p>
      <a
        class="title gogu-part"
        href="https://ccass.gogudata.com/"
        target="_blank"
        rel="nofollow"
      >券商席位查询</a>
      <a
        class="title gogu-part"
        href="https://gogudata.com/HKsearch"
        target="_blank"
        rel="nofollow"
      >港股通</a>
      <a
        class="title gogu-part"
        href="https://gogudata.com/moneyFlow"
        target="_blank"
        rel="nofollow"
      >资金流动</a>
      <a
        class="title gogu-part"
        href="https://gogudata.com/option-search"
        target="_blank"
        rel="nofollow"
      >期权透视</a>
      <div style="background-color:#F1F3F7;width:100%;height:1px;"></div>
      <div class="index_market">
        <div
          class="index_item"
          v-for="(item,index) in indexMarket.indexDataV2List"
          :key="item.name"
        >
          <div class="name">{{item.name}}</div>
          <div class="data">
            <div class="num">
              <p
                class="value"
                :style="{'color': item.change > 0 ? '#ED2C1D' : '#0FA538'}"
              >{{item.value}}</p>
              <span :style="{'color': item.change > 0 ? '#ED2C1D' : '#0FA538'}">{{item.change}}</span>
              <span
                class="net_change"
                :style="{'color': item.change > 0 ? '#ED2C1D' : '#0FA538'}"
              >({{(item.netChange*100).toFixed(2)}}%)</span>
            </div>
            <div
              :id="'charts'+index"
              class="chart"
            ></div>
          </div>
        </div>

        <div class="sh">
          <div class="name">港股通(深)</div>
          <div class="data">
            <div class="hk">
              <p>
                <span class="hk-title">资金流入 : </span>
                <span class="hk-num">{{hksz.flowIn}}亿</span>
              </p>
              <p>
                <span class="hk-title">余额 : </span>
                <span class="hk-num">{{hksz.balance}}亿</span>
              </p>
            </div>
            <div id="c1"></div>
          </div>
        </div>
        <div class="hu">
          <div class="name">港股通(沪)</div>
          <div class="data data1">
            <div class="hk">
              <p>
                <span class="hk-title">资金流入 : </span>
                <span class="hk-num">{{hksh.flowIn}}亿</span>
              </p>
              <p>
                <span class="hk-title">余额 : </span>
                <span class="hk-num">{{hksh.balance}}亿</span>
              </p>
            </div>
            <div id="c2"></div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import HighCharts from "highcharts";
import { TSMethodSignature } from 'babel-types';
export default {
  props: ['indexMarket'],
  data() {
    return {
      timeLineArr1: [],//时间数组，前三个图表的横轴
      seriesData1: [],//前三个图表的数据轴
      hksz: {
        date: [],
        data: [],
        flowIn: 0,
        balance: 0
      },
      hksh: {
        date: [],
        data: [],
        flowIn: 0,
        balance: 0,
      },

    }
  },

  mounted() {
    this.flowIn()
    this.getCharts()
  },
  methods: {
    flowIn() {
      if (!this.indexMarket || !this.indexMarket.hkConnectMinLine) { return; }
      let hkConnectMinLine = this.indexMarket.hkConnectMinLine
      this.hksz.flowIn = (hkConnectMinLine[hkConnectMinLine.length - 1][3] / 100000000).toFixed(2)
      this.hksh.flowIn = (hkConnectMinLine[hkConnectMinLine.length - 1][2] / 100000000).toFixed(2)
      this.hksz.balance = (this.indexMarket.hkConnectSZBalance / 100000000).toFixed(2)
      this.hksh.balance = (this.indexMarket.hkConnectSHBalance / 100000000).toFixed(2)

    },
    getCharts() {
      if (!this.indexMarket || !this.indexMarket.indexDataV2List) { return; }
      let indexDataV2List = this.indexMarket.indexDataV2List
      for (let i = 0; i < indexDataV2List.length; i++) {
        this.timeLineArr1 = []
        this.seriesData1 = []
        if (!indexDataV2List[i].timeLine) {
          this.timeLineArr1 = []
          this.seriesData1 = []
        } else {
          for (let j = 0; j < indexDataV2List[i].timeLine.length; j++) {
            this.timeLineArr1.push(indexDataV2List[i].timeLine[j][0])
            this.seriesData1.push(indexDataV2List[i].timeLine[j][1] / 1)
          }
        }

        //前三个图表
        HighCharts.chart('charts' + i, {
          chart: {
            type: 'line',
            width: 69,
            height: 43,
            margin: [0, 0, 0, 0],
            spacing: [0, 0, 0, 0],
          },
          colors: [
            indexDataV2List[i].change > 0 ? '#ED2C1D' : '#0FA538'
          ],
          title: {
            text: null
          },
          credits: {
            enabled: false
          },
          legend: {
            enabled: false
          },
          tooltip: {
            hideDelay: 100,
            padding: 0,
            formatter: function () {
              return this.x + '<br />' + this.y
            },
          },
          plotOptions: {
            series: {
              // fillOpacity:0.1,
              marker: {
                enabled: false,
              }
            }
          },
          xAxis: {
            lineWidth: 0,
            tickWidth: 0,
            labels: {
              enabled: false
            },
            categories: this.timeLineArr1   // x 轴分类
          },
          yAxis: {
            tickWidth: 0,
            gridLineWidth: 0,
            labels: {
              enabled: false
            },
            title: {
              text: null            // y 轴标题
            }
          },
          series: [{
            lineWidth: 1,                           // 数据列名
            data: this.seriesData1       // 数据
          }]
        })
      }

      this.hksz.date = []
      this.hksz.data = []
      this.hksh.data = []
      if (!this.indexMarket || !this.indexMarket.hkConnectMinLine) return;
      let hkConnectMinLine = this.indexMarket.hkConnectMinLine

      for (let i = 0; i < hkConnectMinLine.length; i++) {
        this.hksz.date.push(hkConnectMinLine[i][0])
        this.hksz.data.push(hkConnectMinLine[i][3] / 1000000)   //数据轴值必须是Number
        this.hksh.data.push(hkConnectMinLine[i][2] / 1000000)
      }
      HighCharts.chart('c1', {
        chart: {
          type: 'line',
          width: 69,
          height: 43,
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0],          //指定图表的类型，默认是折线图（line）
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        tooltip: {
          hideDelay: 100,
          padding: 0,
          formatter: function () {
            return this.x + '<br />' + this.y.toFixed(2)
          },
        },
        legend: {
          enabled: false
        },
        plotOptions: {

          series: {
            fillOpacity: 0.1,
            marker: {
              enabled: false,
            }
          }
        },
        xAxis: {
          lineWidth: 0,
          tickWidth: 0,
          labels: {
            enabled: false
          },
          categories: this.hksz.date
        },
        yAxis: {
          tickWidth: 0,
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            text: null
          }
        },
        series: [{
          lineWidth: 1,
          color: '#ED2C1D',
          data: this.hksz.data
        }]
      })
      HighCharts.chart('c2', {
        chart: {
          type: 'line',
          width: 69,
          height: 43,
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0],
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        tooltip: {
          hideDelay: 100,
          padding: 0,
          formatter: function () {
            return this.x + '<br />' + this.y.toFixed(2)
          },
        },
        plotOptions: {

          series: {
            fillOpacity: 0.1,
            marker: {
              enabled: false,
            }
          }
        },
        xAxis: {
          lineWidth: 0,
          tickWidth: 0,
          labels: {
            enabled: false
          },
          categories: this.hksz.date
        },
        yAxis: {
          tickWidth: 0,
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            text: null
          }
        },
        series: [{
          lineWidth: 1,
          color: '#ED2C1D',
          data: this.hksh.data
        }]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.stock-index {
  width: 100%;
  .title {
    font-weight: bold;
    color: #222222;
    font-size: 18px;

    display: inline-block;
    padding-bottom: 12px;
    border-bottom: 3px solid #3278d2;
  }
  .gogu-part {
    font-weight: normal;
    border-bottom: none !important;
    margin-left: 20px;
  }
  .gogu-part:hover {
    cursor: pointer;
    color: #3278d2;
  }
}

.index_market {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.index_item {
  width: 224px;
}

.data {
  border-right: 1px solid #e8e8e8;
}
.data1 {
  border-right: 0px;
}

.name {
  margin-top: 19px;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #222222;
}
.value {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 10px;
}
.data .num {
  display: inline-block;
}

.sh,
.hu {
  width: 224px;
}
.hk {
  display: inline-block;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  .hk-num {
    font-size: 16px;
    color: #ed2c1d;
  }
}
.hk p {
  margin-top: 13px;
  margin-bottom: 14px;
}
.chart {
  display: inline-block;
  width: 69px;
  height: 43px;
  float: right;
  margin-top: 16px;
  margin-right: 20px;
}
#c1 {
  display: inline-block;
  width: 69px;
  height: 43px;
  float: right;
  margin-top: 16px;
  margin-right: 20px;
}
#c2 {
  display: inline-block;
  width: 69px;
  height: 43px;
  float: right;
  margin-top: 16px;
  margin-right: 20px;
}
.net_change {
  display: inline-block;
}
</style>

